export default __webpack_public_path__ + "static/media/rarea_ChristmasTree.48263bdf.glb";